import { PostAPI, PostAPIWithoutRequest } from "../helper/apiHelper";

export const SelectOwner = async (request: any) => {
  return PostAPI(request, 'PropertyOwnerMaster/SelectByUserID');
};

export const InsertPropertyOwnerDetails = async (request: any) => {
  return PostAPI(request, 'PropertyOwnerMaster/Insert');
};

export const InsertPropertyDetails = async (request: any) => {
  return PostAPI(request, 'PGPropertyDetails/InsertDetails');
};

export const InsertFinancialDetails = async (request: any) => {
  return PostAPI(request, 'PGPropertyDetails/Insert');
};

export const SelectFinancialDetails = async (request: any) => {
  return PostAPI(request, 'PGPropertyDetails/SelectByUserID');
};

export const SelectDetails = async (request: any) => {
  return PostAPI(request, 'PGPropertyDetails/SelectDetailsByUserID');
};
export const SelectedAmenities = async (request: any) => {
  return PostAPI(request, 'PGPropertyDetails/SelectAmenities');
};

export const SelectAmenitiesType = async () => {
  return PostAPIWithoutRequest('AmenitiesType/SelectPGAmenitiesType');
};

export const InsertSelectedAmenities = async (request: any) => {
  return PostAPI(request, 'PGPropertyDetails/InsertAmenities');
};

export const InsertMultipleFiles = async (request: any) => {
  return PostAPI(request, 'PGPropertyDetails/InsertMultipleFiles');
};

export const deleteFile = async (request: any) => {
  return PostAPI(request,'PGPropertyDetails/Delete');
};

export const SelectMultipleFiles = async (request: any) => {
  return PostAPI(request,'PGPropertyDetails/SelectFilesByUserID');
};

export const SearchProperty = async (request: any) => {
  return PostAPI(request,'PGPropertyDetails/SearchProperties');
};